<template>
  <w-flex grow class="justify-space-between align-center ma3 smd-column">
    <div>
      <w-select class="fill-width" v-model="elements" :items="paginationStore.state.sizes.map(s => { return { label: s } })"
        label="Elements for page " label-position="left" @item-select="(e) => paginationStore.elemetsPerPage(e.value)"
        :disabled="disabled" />
    </div>
    <div class="spacer"></div>
    <w-flex grow class="justify-center align-center ma3 smd-xs12 ">
      <w-button round :disabled="disableBack" @click="() => paginationStore.previousPage()">
        <w-icon class="mr1">mdi mdi-arrow-left</w-icon>
      </w-button>

      <span class="mx2">
        <!-- show first 3 numbers -->
        <span v-for="index in 4" :key="index">
          <span :id="'pagnum-first-' + index" v-if="
            index - 1 < paginationStore.getPagination().currentPage + 4 &&
            index <= paginationStore.getPagination().pages
          " :hidden="paginationStore.getPagination().currentPage > 3 && index > 1">
            <PageTag :disabled="disabled" :page="paginationStore.getPagination().currentPage + 1" :value="index"
              @toPageEvent="() => paginationStore.toPage(index - 1)" />
          </span></span>
        <span :hidden="paginationStore.getPagination().currentPage < 4">...
        </span>

        <!-- show current + closest 4 numbers -->
        <span v-for="index in [-2, -1, 0, 1, 2]" :key="index">
          <span :id="'pagnum-central-' + index" v-if="(paginationStore.getPagination().currentPage + index) + 1 > 0 &&
            paginationStore.getPagination().currentPage >= 4 &&
            paginationStore.getPagination().currentPage <
            paginationStore.getPagination().pages - (1 + 4)
          " :hidden="paginationStore.getPagination().pages < 4">
            <PageTag :disabled="disabled" :page="paginationStore.getPagination().currentPage + 1"
              :value="paginationStore.getPagination().currentPage + index + 1" @toPageEvent="() =>
                  paginationStore.toPage(
                    paginationStore.getPagination().currentPage + index
                  )
                " />
          </span>
        </span>

        <!-- show last 3 numbers -->
        <span :hidden="paginationStore.getPagination().currentPage + 1 >=
          paginationStore.getPagination().pages - 4 &&
          paginationStore.getPagination().pages - 4 < 4
          ">
          ... </span>
        <span v-for="index in [4, 3, 2, 1, 0]" :key="index">
          <span :id="'pagnum-last-' + index" v-if="
            paginationStore.getPagination().currentPage - index + 1 > 0 && paginationStore.getPagination().pages &&
            paginationStore.getPagination().currentPage + 1 - index <=
            paginationStore.getPagination().pages
          " :hidden="paginationStore.getPagination().pages <= 4 ||
            paginationStore.getPagination().currentPage + 1 <
            paginationStore.getPagination().pages - 4 && index > 0 ||
            paginationStore.getPagination().pages - 4 < 4 && index > 0 && paginationStore.getPagination().currentPage + 1 <= 4
            ">
            <PageTag :disabled="disabled" :page="paginationStore.getPagination().currentPage + 1"
              :value="paginationStore.pagination.pages - index" @toPageEvent="() =>
                  paginationStore.toPage(
                    paginationStore.getPagination().pages - (index + 1)
                  )
                " />
          </span>
        </span>
      </span>

      <w-button c round :disabled="disableNext" @click="() => paginationStore.nextPage()">
        <w-icon class="mr1">mdi mdi-arrow-right</w-icon>
      </w-button> </w-flex>
    <div class="spacer"></div>
    <span v-if="paginationStore.getPagination().totalElements"> {{
      (paginationStore.getPagination().currentPage * paginationStore.paginationParams.elements) + 1 }} - {{
        (paginationStore.getPagination().currentPage * paginationStore.paginationParams.elements) + paginationStore.getPagination().elements
      }} of {{ paginationStore.getPagination().totalElements }} </span>
  </w-flex>
  <!-- <div>
    {{ paginationStore.pagination }}
  </div>
  
  <div>
    {{ paginationStore.paginationParams }}
  </div> -->
</template>

<script>
// import {SessionData} from "@/models/RobotResponse";
import {
  //  ref,
  //   reactive,
  //   onMounted,
  //   watch,
  computed,
  // , computed,  onUnmounted
} from "vue";
import PageTag from "./PageTag.vue";

export default {
  name: "PaginationNav",
  props: {
    paginationStore: Object,
  },
  setup: (props) => {
    const disabled = computed(() => props.paginationStore.state.loading)
    const elements = computed(() => props.paginationStore.paginationParams.elements)
    const disableBack = computed(() => {
      if (props.paginationStore && !disabled.value) {
        return props.paginationStore.getPagination().currentPage
          ? props.paginationStore.getPagination().currentPage <= 0
          : true;
      }
      return true;
    });
    const disableNext = computed(() => {
      if (props.paginationStore && !disabled.value) {
        return props.paginationStore.getPagination().pages
          ? props.paginationStore.getPagination().currentPage >=
          props.paginationStore.getPagination().pages - 1
          : true;
      }
      return true;
    });
    // async function next() {
    //   console.log("next");
    //   await paginationStore.next();
    // }
    return {
      elements,
      disableBack,
      disableNext,
      disabled
    };
  },
  components: { PageTag },
};
</script>
